import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconSearch = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-search' + (className ? ` ${className}` : '')}
            fill='none'
            height='20'
            viewBox='0 0 20 20'
            width='20'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M8.016 12.68q-1.948 0-3.314-1.367Q3.337 9.948 3.336 8q0-1.947 1.366-3.313T8.015 3.32t3.314 1.366Q12.694 6.052 12.695 8q0 .816-.269 1.562T11.7 10.91l4.586 4.587q.174.173.177.372.005.2-.177.38a.54.54 0 0 1-.387.182.54.54 0 0 1-.387-.181l-4.587-4.566a5 5 0 0 1-1.37.735q-.745.26-1.54.26m0-1.084q1.506 0 2.55-1.045Q11.613 9.507 11.613 8t-1.045-2.551Q9.522 4.404 8.015 4.404q-1.506 0-2.55 1.045-1.047 1.045-1.046 2.55 0 1.508 1.045 2.552t2.551 1.045'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconSearch;
